/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { blankEnumSchema } from "./blankEnumSchema.ts";
import { customRenderEnumSchema } from "./customRenderEnumSchema.ts";
import { localizationStrSchema } from "./localizationStrSchema.ts";
import { modifierSchema } from "./modifierSchema.ts";
import { nullEnumSchema } from "./nullEnumSchema.ts";

export const productGroupModifierSchema = z.object({
	id: z.uuid(),
	name: z.string(),
	required: z.boolean().optional(),
	default_amount: z.int().min(0).max(2147483647).optional(),
	min_amount: z.int().min(0).max(2147483647).optional(),
	max_amount: z.int().min(0).max(2147483647).optional(),
	free_quantity: z.int().min(0).max(2147483647).nullish(),
	description: z.string(),
	group_modifiers: z.array(modifierSchema),
	image_link: z.string().nullable(),
	is_fake: z.boolean().optional(),
	is_product_determining: z
		.boolean()
		.optional()
		.describe(
			"Используется только для fake групп модификаторов. Позволяет определить какое из блюд среди another_related_product_with_same_size использовать. Например, позволяет определить выбор между 'Какао Grand' и 'Какао Grand альт' на основе выбора модификатора молока.",
		),
	loc_name: localizationStrSchema.describe("Util serializer for representation in swagger"),
	custom_render: z.union([customRenderEnumSchema, blankEnumSchema, nullEnumSchema]).nullish(),
});
